//@ts-ignore
import styles from './ProductVideoTab.module.css'

export interface ProductVideoTabProps {
  poster: string
  src: string
}

// Local mp4 only. The viewer unmounts a tab when another one is chosen, so the
// video stops with it.
export default function ProductVideoTab({ poster, src }: ProductVideoTabProps) {
  return (
    <div className={styles['root']}>
      <video
        className={styles['video']}
        controls
        playsInline
        poster={poster || undefined}
        preload="metadata"
        src={src}
      />
    </div>
  )
}
